import React from 'react';
import * as actions from '../Actions';
import ShareOptions from '../ShareOptions';

export default function ({ highlightsfeed, eleRef }) {
    return ( 

<section className="main_container_block_feeds baby_view_more">
<div className="main_block_container_feed">
      <div className="block_container_feed_heading_text baby_name_header R15_61">
         Quiz for you
      </div>
      <div className="uploard-photo-section_main">
      <div className="content-div_view_artical">
         <img src={highlightsfeed.data && highlightsfeed.data[0] ?highlightsfeed.data[0].templateImage:''} alt="logo" onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"}}/>
      </div>
     <div className="button-view_milestone border_top_btns">
      <a href={highlightsfeed.data[0].redirectUrl} >
        <button data-name={highlightsfeed.data[0].quizName} className="M16_white gtm-participate-now" type="button">Participate now</button>
      </a>
        <div id="dev_quiz" style={{ 'display': 'none' }}>{highlightsfeed.data && highlightsfeed.data[0] ? highlightsfeed.data[0].quizName:''}  
                                                 </div>
    </div>
   </div>
  </div>
</section>
    )
}
